import { TypeAnimation } from 'react-type-animation';

const Typewriter = () => {
  return (
    <>&nbsp;
      <TypeAnimation
        sequence={[
          " ",
          1000,
          " a Developer",
          2000,
          " a Designer",
          1500,
          " a Teacher",
          2000,
          "",
          1500,
          " Ash",
          3000,
          " Ash...",
          2000,
          " Ash...um",
          1500,
          " Ash...um.....hi",
          15000,
          " gonna start over ok?",
          3000
        ]}
        speed={40}
        repeat={Infinity}
        style={{ fontSize: "1em", color: "black" }}
      />
    </>
  );
};

export default Typewriter;
